import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import CheckboxTree from 'react-checkbox-tree';
import './CheckBoxTreeView.css';
import MinusBox from './icons/minus-box';
import PlusBox from './icons/plus-box';

function CheckBoxTreeView({ values, labels, parent_values, checked, checkCallBack }) {
  const [entities, setEntities] = useState([]);
  const [checkedState, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    formatEntities();
  }, [values, labels, parent_values, checked]);

  const getEntityChildren = entity => {
    const children = entities
      .filter(e => e.parent_value === entity.value)
      .map(formatEntityWithChildren);
    return children;
  };

  const handleOnExpand = expanded => {
    setExpanded(expanded);
  };

  const handleCheck = checked => {
    checkCallBack(checked);
    setChecked(checked);
  };

  const formatEntityWithChildren = entity => {
    const children = getEntityChildren(entity);
    return {
      value: entity.value,
      label: entity.label,
      parent_value: entity.parent_value,
      children: children.length > 0 ? children : null,
    };
  };

  const mountData = (entitiesData) => {
    const data = entitiesData
      .filter(entity => entity.parent_value == null)
      .map(entity => ({
        value: entity.value,
        label: entity.label,
        parent_value: entity.parent_value,
        children: getEntityChildren(entity),
      }));

    setData(data);
  };

  const formatEntities = () => {
    if (!values) return;

    const entities = values.map((value, index) => ({
      value,
      label: labels[index],
      parent_value: parent_values[index],
    }));

    const checkedEntities = entities
      .filter(entity => checked.includes(entity.value.toString()))
      .map(entity => entity.value);

    setEntities(entities);
    setChecked(checkedEntities);
    mountData(entities);
  };

  const iconStyle = {
    height: '40px',
    padding: '8px',
    position: 'relative',
    right: '12px',
  };

  return (
    <div className="container">
      <div className="checkbox">
        <CheckboxTree
          nodes={data}
          expanded={expanded}
          checked={checkedState}
          onCheck={handleCheck}
          onExpand={handleOnExpand}
          noCascade
          showNodeIcon={false}
          icons={{
            check: <Checkbox color="primary" style={iconStyle} checked />,
            uncheck: <Checkbox color="primary" style={iconStyle} checked={false} />,
            expandClose: <PlusBox />,
            expandOpen: <MinusBox />,
          }}
        />
      </div>
    </div>
  );
}

CheckBoxTreeView.propTypes = {
  checkCallBack: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  parent_values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  checked: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
};

export default CheckBoxTreeView;
